import _ from 'lodash';
window._ = _;

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

import axios from 'axios';
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

import Swal from 'sweetalert2'
window.Swal = Swal

window.Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
})

import Vue from 'vue'

Vue.mixin({
    methods: {
        previewFile(file){

            if(file  !== null ){
                if(file && typeof file ==='object'){
                    return URL.createObjectURL(file);
                }else{
                    return file
                }

            }else {
                if (true) return;
                return URL.createObjectURL(file);
            }
        },
        goBack(){
            history.back()
        }
    }
})

